import { useState, useEffect } from 'react'
import { connect } from 'react-redux'

// Redux
import {
  socketDocumentCreated,
  socketDocumentUpdated,
  socketDocumentUpload,
} from 'Redux/Actions/LedgerActions'

const DOCUMENT_UPDATE = 'DOCUMENT_UPDATE'
const DOCUMENT_CREATION = 'DOCUMENT_CREATION'
const DOCUMENT_UPLOAD = 'DOCUMENT_UPLOAD'
const AuthTokenKey = 'authToken'
const SOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL
const socket = new WebSocket(SOCKET_URL)

const WebSocketConstructer = (props) => {
  const { socketDocumentCreated, socketDocumentUpdated, socketDocumentUpload } = props
  const [authToken, setAuthToken] = useState('')

  useEffect(() => {
    setAuthToken(localStorage.getItem(AuthTokenKey))
  }, [])

  useEffect(() => {
    socket.onopen = function (e) {
      const authData = JSON.stringify({
        message: 'authenticate',
        data: { environment: 'retriever', token: authToken },
      })
      socket.send(authData)
    }
  }, [authToken])
  socket.onmessage = function (event) {
    let eventData = {}
    try {
      eventData = JSON.parse(event.data)
    } catch {}
    if (!eventData?.data) {
      return
    }
    if (eventData?.metadata?.messageType === DOCUMENT_CREATION) {
      socketDocumentCreated(eventData?.data)
    }
    if (eventData?.metadata?.messageType === DOCUMENT_UPDATE) {
      socketDocumentUpdated(eventData?.data)
    }
    if (eventData?.metadata?.messageType === DOCUMENT_UPLOAD) {
      socketDocumentUpload(eventData?.data)
    }
  }
  socket.onclose = function (event) {
    if (event.wasClean) {
      console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`)
    } else {
      console.log('[close] Connection died')
    }
  }

  socket.onerror = function (error) {
    console.log(`[error] ${JSON.stringify(error)}`)
  }

  return null
}

const mapDispatchToProps = {
  socketDocumentCreated,
  socketDocumentUpdated,
  socketDocumentUpload,
}

export default connect(null, mapDispatchToProps)(WebSocketConstructer)
